export default function getDocumentTimeElapsed() {
  return Date.now();
}
